/** Ids dos atletas da prévia, sem depender de three (o modo Treino usa nos roteiros). */
export const PLAYER_ID = "jogador";
export const parkedId = (i: number) => `parado-${String(i).padStart(2, "0")}`;
